<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import repsView from "@/components/reps/repsView.vue";

/**
 * Starter component
 */
export default {
    page: {
        title: "Reps",
        meta: [{ name: "description", content: appConfig.description }],
    },
    components: { Layout, PageHeader, repsView },
    data() {
        return {
            title: "Reps",
            items: [
                {
                    text: "Reps",
                    active: true,
                },
            ],
        };
    },
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <repsView />
    </Layout>
</template>
